
import React, { useEffect, useState, useCallback, useRef } from "react";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Loader from "../../elements/Loader";
import { toast } from "react-toastify";
import { useDropzone } from 'react-dropzone';
import ApiService from "../../services/apiService";
import Select from "react-select";
import JoditEditor from "jodit-react";
import { DndContext, closestCenter, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { arrayMove, SortableContext, useSortable, rectSortingStrategy } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

function SortableImage({ item, index, onRemove }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: item.id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.4 : 1,
    zIndex: isDragging ? 100 : 'auto',
  };
  return (
    <div ref={setNodeRef} style={{ ...style, position: 'relative', display: 'inline-block' }} {...attributes}>
      <div style={{ width: 110, height: 110, borderRadius: 8, overflow: 'hidden', border: index === 0 ? '2px solid #6610f2' : '2px solid #dee2e6', position: 'relative' }}>
        <img src={item.preview || item.url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} draggable={false} />
        <div
          {...listeners}
          style={{ position: 'absolute', top: 4, left: 4, cursor: 'grab', background: 'rgba(0,0,0,0.55)', borderRadius: 4, padding: '2px 5px', color: 'white', fontSize: 14, lineHeight: 1, userSelect: 'none' }}
          title="Drag to reorder"
        >⠿</div>
        <button
          type="button"
          onClick={() => onRemove(item.id)}
          style={{ position: 'absolute', top: 3, right: 3, background: 'rgba(220,53,69,0.9)', border: 'none', borderRadius: '50%', width: 20, height: 20, color: 'white', cursor: 'pointer', fontSize: 14, lineHeight: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0 }}
        >×</button>
        {index === 0 && (
          <span style={{ position: 'absolute', bottom: 0, left: 0, right: 0, textAlign: 'center', background: 'rgba(102,16,242,0.85)', color: 'white', fontSize: 9, fontWeight: 700, padding: '2px 0', letterSpacing: 1 }}>
            COVER
          </span>
        )}
      </div>
    </div>
  );
}

export default function AddPuja() {
  const params = useParams();
  const { id } = params;
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [galleryImages, setGalleryImages] = useState([]);
  const [tag, setTag] = useState([]);
  const [userChecklistPdf, setUserChecklistPdf] = useState(null);
  const [panditChecklistPdf, setPanditChecklistPdf] = useState(null);
  const [galleryVideos, setGalleryVideos] = useState([]);
  const [previewVideoUrl, setPreviewVideoUrl] = useState(null);
  const videoInputRef = useRef(null);

  // Variant-related state
  const [variants, setVariants] = useState([]);
  const [showAddVariantModal, setShowAddVariantModal] = useState(false);
  const [newVariantType, setNewVariantType] = useState('');
  const [baseVariantName, setBaseVariantName] = useState('Basic');

  // Track which ID we are currently editing (Main or Variant)
  // Initialize with the URL id (Main Puja)
  const [currentEditId, setCurrentEditId] = useState(id);

  const [initialValues, setInitialValues] = useState({
    title: "",
    image: "",
    price: 0,
    description: "",
    includes: "",
    duration: "",
    info: "",
    inclusions: "",
    legendsAndFables: "",
    ritualPhilosophy: "",
    pujaVidhi: "",
    samagri: "",
    isActive: false,
    tag: [],
    checklist: {},
    panditPayout: 0,
    acharyaBilling: 0,
    culturalAcceptance: "",
    shortDescription: "",
    offerings: [],
    videoUrl: "",
    videoTitle: "",
    usp: "",
    showOnCarousel: false,
    isCustomPuja: false,
    userChecklistUrl: "",
    panditChecklistUrl: "",
    slug: ""
  })

  // Update currentEditId only if id actually changes from the URL
  useEffect(() => {
    if (id) {
      setCurrentEditId(prev => {
        // Only update if it's currently null or if the URL id changed
        if (!prev || prev !== id) {
          return id;
        }
        return prev;
      });
    }
  }, [id]);

  const validationSchema = Yup.object().shape({
    title: Yup.string().required(),
    image: Yup.string(),
    price: Yup.number().min(1),
    description: Yup.string(),
    includes: Yup.string(),
    duration: Yup.string(),
    info: Yup.string(),
    //inclusions: Yup.array(),
    legendsAndFables: Yup.string(),
    ritualPhilosophy: Yup.string(),
    pujaVidhi: Yup.string(),
    samagri: Yup.string(),
    panditPayout: Yup.number().min(1, 'Acharya payout must be greater than or equal to 1'),

  });


  const config = {
    buttons: [
      "align", // Alignment tools
    ],
    removeButtons: [
      "strikeThrough", // Remove strike
      "fullsize", // Remove fullsize button
      "video", // Remove video recording
      "source", // Re
      "indent", // Remove increase indent
      "outdent", // Remove decrease indent
      "speechRecognition", // Remove speech recognition
      "showall", // Remove show all
      "speech"
    ],
    showPoweredBy: false, // Remove "Powered by Jodit" branding
    toolbarSticky: false, // Prevent toolbar from sticking while scrolling
    showXPathInStatusbar: false,
    placeholder: "",
  };

  const parseGalleryImages = (data) => {
    if (Array.isArray(data.images) && data.images.length > 0) {
      return data.images.map(url => ({ id: `${Date.now()}-${Math.random().toString(36).slice(2)}`, url, file: null, preview: url }));
    }
    if (data.image) {
      return [{ id: `${Date.now()}-${Math.random().toString(36).slice(2)}`, url: data.image, file: null, preview: data.image }];
    }
    return [];
  };

  const removeGalleryImage = useCallback((imgId) => {
    setGalleryImages(prev => {
      const target = prev.find(i => i.id === imgId);
      if (target?.file && target.preview) URL.revokeObjectURL(target.preview);
      return prev.filter(i => i.id !== imgId);
    });
  }, []);

  const sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 5 } }));

  const handleDragEnd = useCallback((event) => {
    const { active, over } = event;
    if (over && active.id !== over.id) {
      setGalleryImages(items => {
        const oldIdx = items.findIndex(i => i.id === active.id);
        const newIdx = items.findIndex(i => i.id === over.id);
        return arrayMove(items, oldIdx, newIdx);
      });
    }
  }, []);

  const onGalleryDrop = useCallback((acceptedFiles) => {
    const newItems = acceptedFiles.map(file => ({
      id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
      url: null, file, preview: URL.createObjectURL(file)
    }));
    setGalleryImages(prev => [...prev, ...newItems].slice(0, 10));
  }, []);

  const { getRootProps: getGalleryRootProps, getInputProps: getGalleryInputProps } = useDropzone({
    onDrop: onGalleryDrop,
    accept: { 'image/*': [] },
    multiple: true
  });

  // ── Video gallery helpers ──────────────────────────────────────────────────

  const parseGalleryVideos = (data) => {
    if (Array.isArray(data.videos) && data.videos.length > 0) {
      return data.videos.map(v => ({
        id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
        url: v.url, file: null,
        name: v.url.split('/').pop(),
        showOnCarousel: v.showOnCarousel || false,
        uploading: false, progress: 0
      }));
    }
    if (data.videoUrl) {
      return [{
        id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
        url: data.videoUrl, file: null,
        name: data.videoUrl.split('/').pop(),
        showOnCarousel: data.showOnCarousel || false,
        uploading: false, progress: 0
      }];
    }
    return [];
  };

  const toggleVideoCarousel = useCallback((videoId) => {
    setGalleryVideos(prev => prev.map(v => ({
      ...v,
      showOnCarousel: v.id === videoId ? !v.showOnCarousel : false
    })));
  }, []);

  const removeVideo = useCallback((videoId) => {
    setGalleryVideos(prev => prev.filter(v => v.id !== videoId));
  }, []);

  const handleAddVideoClick = () => {
    if (videoInputRef.current) videoInputRef.current.click();
  };

  const handleVideoFileSelected = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    e.target.value = '';

    const newItem = {
      id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
      url: null, file, name: file.name,
      showOnCarousel: false, uploading: true, progress: 0
    };

    setGalleryVideos(prev => [...prev, newItem]);

    try {
      const { uploadFileMultipart } = await import('../../services/multipartUpload');
      const url = await uploadFileMultipart(file, (percent) => {
        setGalleryVideos(prev => prev.map(v =>
          v.id === newItem.id ? { ...v, progress: percent } : v
        ));
      });
      setGalleryVideos(prev => prev.map(v =>
        v.id === newItem.id ? { ...v, url, file: null, uploading: false, progress: 100 } : v
      ));
    } catch (err) {
      toast.error(`Video upload failed: ${file.name}`);
      setGalleryVideos(prev => prev.filter(v => v.id !== newItem.id));
    }
  };

  // Helper to map API response to form values
  const mapPujaToInitialValues = (data) => {
    const {
      title, image, price, description, includes, duration, info, inclusions,
      legendsAndFables, ritualPhilosophy, pujaVidhi, samagri, isActive,
      Categories, checklist, panditPayout, userChecklistUrl, panditChecklistUrl,
      culturalAcceptance, shortDescription, videoUrl, videoTitle, usp,
      showOnCarousel, variant, variantType, isCustomPuja
    } = data;

    let preselectedTags = [];
    if (Categories && Categories.length > 0) {
      preselectedTags = Categories.map((item) => ({
        value: item?.id,
        label: item?.name
      }));
    }

    return {
      title: title || "",
      image: image || "",
      price: price || 0,
      description: description || "",
      includes: includes || "",
      duration: duration || "",
      info: info || "",
      inclusions: inclusions || "",
      legendsAndFables: legendsAndFables || "",
      ritualPhilosophy: ritualPhilosophy || "",
      pujaVidhi: pujaVidhi || "",
      samagri: samagri || "",
      isActive: isActive || false,
      tag: preselectedTags,
      checklist: checklist || {},
      panditPayout: panditPayout || 0,
      acharyaBilling: data.acharyaBilling || 0,
      culturalAcceptance: culturalAcceptance || "",
      shortDescription: shortDescription || "",
      offerings: data.offerings || [],
      videoUrl: videoUrl || "",
      videoTitle: videoTitle || "",
      usp: usp || "",
      showOnCarousel: showOnCarousel || false,
      variant: variant || "",
      variantType: variantType || "",
      isCustomPuja: isCustomPuja || false,
      userChecklistUrl: userChecklistUrl || "",
      panditChecklistUrl: panditChecklistUrl || "",
      slug: data.slug || ""
    };
  };

  const getPujaById = useCallback(async (fetchId = currentEditId, updateVariants = true) => {
    if (!fetchId) return;

    setLoading(true);

    ApiService.get(`service/${fetchId}/admin`).then((data) => {
      if (data?.result) {
        const pujaData = data.result;
        const { variants: pujaVariants, parentId } = pujaData;

        setInitialValues(mapPujaToInitialValues(pujaData));
        setGalleryImages(parseGalleryImages(pujaData));
        setGalleryVideos(parseGalleryVideos(pujaData));

        // Only update variants list if we fetched the Main Puja (parentId is null)
        if (updateVariants && parentId === null && pujaVariants) {
          setVariants(pujaVariants);
          setBaseVariantName(pujaData.variantType || 'Basic');
        } else if (parentId !== null) {
          // If we fetched a variant, update it in the local variants list to keep it in sync
          setVariants(prev => prev.map(v => v.id === pujaData.id ? pujaData : v));
        }
      }
      setLoading(false);
    }).catch((err) => {
      toast.error(err?.response?.data || "Failed to fetch puja details");
      setLoading(false);
    });
  }, []); // Removed currentEditId from dependency to avoid recreation

  const getTags = useCallback(async () => {
    // setLoading(true) // Don't block whole UI for tags
    ApiService.get('category').then((response) => {
      // setLoading(false)
      if (response) {
        const options = response.data.map((item) => ({
          value: item.id,
          label: item.name,
        }))
        setTag(options)
      } else {
        setTag([]);
      }
    }).catch((err) => {
      // setLoading(false)
    })
  }, []);

  useEffect(() => {
    if (id) {
      // Initial load of Main Puja
      // We only call this when the component mounts or when the URL ID changes
      // This fetch will also populate the variants list
      getPujaById(id);
    }
    getTags()
  }, [id, getTags]); // Removed getPujaById from dependencies to prevent re-execution on every render

  // Variant handler functions
  const handleAddVariant = async () => {
    if (!newVariantType.trim()) {
      toast.error('Please enter a variant type name');
      return;
    }
    try {
      setLoading(true);
      // Always create variant for the MAIN puja (id from URL)
      const response = await ApiService.post(`service/${id}/variant`, {
        variantType: newVariantType,
        variant: newVariantType
      });
      if (response.msg === 'success') {
        toast.success('Variant created successfully');
        setVariants([...variants, response.result]);
        setShowAddVariantModal(false);
        setNewVariantType('');

        // Optionally switch to the new variant immediately
        handleSwitchTab(response.result.id);
      }
    } catch (error) {
      toast.error('Failed to create variant');
      console.error('Create variant error:', error);
    } finally {
      setLoading(false);
    }
  };



  const handleDeleteVariant = async (variantId) => {
    if (!window.confirm('Are you sure you want to delete this variant?')) return;
    try {
      await ApiService.delete(`service/variant/${variantId}`);
      setVariants(variants.filter(v => v.id !== variantId));

      // If we deleted the currently active variant, switch back to Main
      if (currentEditId === variantId) {
        handleSwitchTab(id);
      }
      toast.success('Variant deleted successfully');
    } catch (error) {
      toast.error('Failed to delete variant');
      console.error('Delete variant error:', error);
    }
  };

  const handleSwitchTab = (targetId) => {
    setCurrentEditId(targetId);

    // If switching to the main puja (id from URL params)
    if (String(targetId) === String(id)) {
      getPujaById(id, false); // Don't refresh the variants list again
      return;
    }

    // Check if the target is a variant we already have in our list
    const variantData = variants.find(v => String(v.id) === String(targetId));

    if (variantData) {
      // Use the data we already have from the main puja's variants array
      setInitialValues(mapPujaToInitialValues(variantData));
      setGalleryImages(parseGalleryImages(variantData));
      setGalleryVideos(parseGalleryVideos(variantData));
    } else {
      // Fallback: fetch from backend if not found locally
      getPujaById(targetId, false);
    }
  };

  const onSubmit = async (values, { setSubmitting }) => {
    if (galleryVideos.some(v => v.uploading)) {
      toast.warning('Please wait for video uploads to finish before saving.');
      setSubmitting(false);
      return;
    }
    if (
      !values.isCustomPuja &&
      values.acharyaBilling &&
      values.panditPayout &&
      Number(values.acharyaBilling) < Number(values.panditPayout)
    ) {
      toast.error(
        `Acharya Billing amount (₹${values.acharyaBilling}) must be greater than Acharya Payout (₹${values.panditPayout})`,
        { position: "top-right" }
      );
      setSubmitting(false);
      return;
    }
    try {
      // Upload any pending gallery images and build the ordered URL array
      const finalImageUrls = [];
      for (const item of galleryImages) {
        if (item.file) {
          const fd = new FormData();
          fd.append('file', item.file);
          const res = await ApiService.post('upload/image', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
          if (res?.url) finalImageUrls.push(res.url);
        } else if (item.url) {
          finalImageUrls.push(item.url);
        }
      }
      values.images = finalImageUrls;
      if (finalImageUrls.length > 0) values.image = finalImageUrls[0];
      // upload checklist file to S3
      if (userChecklistPdf) {
        const formData = new FormData();
        formData.append('file', userChecklistPdf);
        const uploadResponse = await ApiService.post('upload/pdf', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
        })
        values.userChecklistUrl = uploadResponse.url
        setUserChecklistPdf(null)
      }
      if (panditChecklistPdf) {
        const formData = new FormData();
        formData.append('file', panditChecklistPdf);
        const uploadResponse = await ApiService.post('upload/pdf', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
        })
        values.panditChecklistUrl = uploadResponse.url
        setPanditChecklistPdf(null)
      }
      // Build videos array (all already uploaded during selection)
      const finalVideos = galleryVideos
        .filter(v => v.url)
        .map(v => ({ url: v.url, showOnCarousel: v.showOnCarousel }));
      values.videos = finalVideos;
      // Sync legacy fields so mobile carousel endpoint keeps working
      const carouselVideo = finalVideos.find(v => v.showOnCarousel);
      const firstVideo = finalVideos[0];
      values.videoUrl = carouselVideo?.url || firstVideo?.url || '';
      values.showOnCarousel = !!carouselVideo;
      // const serviceData = { ...values, image };
      if (values.tag.length > 0) {
        values.tag = values.tag.map((tag) => (tag.value))

      }
      // console.log(values, 'values');

      // Use currentEditId if available, otherwise fallback to id (for Main), otherwise creation
      let targetId = currentEditId || id;

      if (targetId) {
        ApiService.put(`/service/${targetId}`, values)
          .then((data) => {
            if (data.msg === 'success') {
              toast.success("Service Updated");
              // Refresh data to show updates
              getPujaById(targetId);
            }
            // DO NOT NAVIGATE - stay on page
            // navigate('/service', { replace: true });
          }).catch((err) => {
            console.log(err)
          })
      } else {

        ApiService.post('/service', values)
          .then((data) => {
            if (data.msg === 'success') {
              toast.success("New Service Added");
              navigate('/service', { replace: true });
            }

          }).catch((err) => {
            console.log(err)
          })
      }
    } catch (error) {
      console.error('Error saving service:', error);
    }
    setSubmitting(false)
  }

  // State for renaming variants
  const [editingVariantId, setEditingVariantId] = useState(null);
  const [editingName, setEditingName] = useState('');

  const startRenaming = (e, variant) => {
    e.stopPropagation(); // Prevent tab switching when starting edit
    setEditingVariantId(variant.id);
    setEditingName(variant.variantType);
  };

  const saveRename = async (variantId) => {
    if (!editingName.trim()) {
      setEditingVariantId(null);
      return;
    }

    setEditingVariantId(null);

    if (String(variantId) === String(id)) {
      const oldValue = baseVariantName;
      setBaseVariantName(editingName);
      try {
        await ApiService.put(`/service/${id}`, { variantType: editingName });
        toast.success('Base variant renamed');
      } catch (error) {
        setBaseVariantName(oldValue);
        toast.error('Failed to rename base variant');
      }
      return;
    }

    // Renaming a child variant — optimistic update
    const oldVariants = [...variants];
    setVariants(variants.map(v =>
      v.id === variantId ? { ...v, variantType: editingName, variant: editingName } : v
    ));

    try {
      await ApiService.put(`service/variant/${variantId}`, {
        variantType: editingName,
        variant: editingName
      });
      toast.success('Variant renamed');
    } catch (error) {
      setVariants(oldVariants);
      toast.error('Failed to rename variant');
    }
  };

  return (
    <div className="row" key={currentEditId}>
      {loading && <Loader />}

      {/* Add Variant Modal */}
      {showAddVariantModal && (
        <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add New Variant</h5>
                <button type="button" className="btn-close" onClick={() => setShowAddVariantModal(false)}></button>
              </div>
              <div className="modal-body">
                <label className="form-label">Variant Type Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="e.g., Variant2, Premium, etc."
                  value={newVariantType}
                  onChange={(e) => setNewVariantType(e.target.value)}
                />
                <small className="text-muted">This will be the tab name. All fields will be copied from main puja.</small>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowAddVariantModal(false)}>Cancel</button>
                <button type="button" className="btn btn-primary" onClick={handleAddVariant}>Create Variant</button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="col-xl-8 col-lg-12 offset-md-2" >
        {/* Chrome-style Variant Tabs - Always show if we have variants or are on main puja */}
        {id && (
          <div style={{ position: 'relative', zIndex: 10 }}>
            <div className="d-flex flex-wrap align-items-end" style={{
              paddingLeft: '5px',
              paddingBottom: '0',
              marginBottom: '0'
            }}>
              {/* Main Puja Tab */}
              <div
                onClick={() => handleSwitchTab(id)}
                style={{
                  padding: '10px 16px',
                  backgroundColor: currentEditId === id ? '#ffffff' : '#e9ecef',
                  color: currentEditId === id ? '#6610f2' : '#495057',
                  borderTopLeftRadius: '10px',
                  borderTopRightRadius: '10px',
                  fontWeight: '600',
                  fontSize: '14px',
                  boxShadow: currentEditId === id ? '0 -2px 5px rgba(0,0,0,0.05)' : 'none',
                  position: 'relative',
                  zIndex: currentEditId === id ? 5 : 1,
                  border: '1px solid #dee2e6',
                  borderBottom: currentEditId === id ? 'none' : '1px solid #dee2e6',
                  cursor: 'pointer',
                  marginRight: '4px',
                  transition: 'all 0.2s',
                  borderTop: currentEditId === id ? '3px solid #6610f2' : '1px solid #dee2e6',
                  display: 'flex', alignItems: 'center', gap: '8px', minWidth: '100px',
                }}
              >
                {editingVariantId === id ? (
                  <input
                    autoFocus
                    value={editingName}
                    onChange={(e) => setEditingName(e.target.value)}
                    onBlur={() => saveRename(id)}
                    onKeyDown={(e) => e.key === 'Enter' && saveRename(id)}
                    onClick={(e) => e.stopPropagation()}
                    style={{
                      border: 'none', background: 'transparent',
                      borderBottom: '1px solid #6610f2', outline: 'none',
                      width: '80px', padding: '0', fontSize: '14px', color: 'inherit',
                    }}
                  />
                ) : (
                  <>
                    {baseVariantName}
                    <div onClick={(e) => e.stopPropagation()} style={{ display: 'flex', gap: '4px', marginLeft: '4px' }}>
                      <span
                        onClick={(e) => { e.stopPropagation(); setEditingVariantId(id); setEditingName(baseVariantName); }}
                        style={{ opacity: 0.4, cursor: 'pointer', fontSize: '14px' }}
                        onMouseEnter={(e) => e.target.style.opacity = 1}
                        onMouseLeave={(e) => e.target.style.opacity = 0.4}
                        title="Rename base variant"
                      >✎</span>
                    </div>
                  </>
                )}
              </div>

              {/* Variant Tabs */}
              {variants.map((variant, index) => (
                <div
                  key={variant.id}
                  onClick={() => handleSwitchTab(variant.id)}
                  style={{
                    padding: '10px 16px',
                    backgroundColor: currentEditId === variant.id ? '#ffffff' : (variant.isCustomPuja ? '#f3e5f5' : '#e9ecef'),
                    color: currentEditId === variant.id ? (variant.isCustomPuja ? '#6f42c1' : '#6610f2') : (variant.isCustomPuja ? '#6f42c1' : '#495057'),
                    borderTopLeftRadius: '8px',
                    borderTopRightRadius: '8px',
                    cursor: 'pointer',
                    fontWeight: variant.isCustomPuja ? '600' : '500',
                    fontSize: '13px',
                    marginRight: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    border: '1px solid #dee2e6',
                    borderBottom: currentEditId === variant.id ? 'none' : '1px solid #dee2e6',
                    zIndex: currentEditId === variant.id ? 5 : 1,
                    position: 'relative',
                    borderTop: currentEditId === variant.id ? `3px solid ${variant.isCustomPuja ? '#6f42c1' : '#6610f2'}` : (variant.isCustomPuja ? '1px solid #dba9f5' : '1px solid #dee2e6'),
                    minWidth: '100px'
                  }}
                  title={`${variant.isCustomPuja ? 'Custom Puja - ' : ''}Status: ${variant.isActive ? 'Active' : 'Inactive'}`}
                >
                  {editingVariantId === variant.id ? (
                    <input
                      autoFocus
                      value={editingName}
                      onChange={(e) => setEditingName(e.target.value)}
                      onBlur={() => saveRename(variant.id)}
                      onKeyDown={(e) => e.key === 'Enter' && saveRename(variant.id)}
                      onClick={(e) => e.stopPropagation()}
                      style={{
                        border: 'none',
                        background: 'transparent',
                        borderBottom: '1px solid #6610f2',
                        outline: 'none',
                        width: '80px',
                        padding: '0',
                        fontSize: '13px',
                        color: 'inherit'
                      }}
                    />
                  ) : (
                    <>
                      {variant.variantType || `Variant${index + 1}`}
                      <span style={{
                        width: '8px',
                        height: '8px',
                        borderRadius: '50%',
                        backgroundColor: variant.isActive ? '#28a745' : '#dc3545',
                        display: 'inline-block'
                      }}></span>

                      {/* Controls Container - Only show for non-custom pujas */}
                      {!variant.isCustomPuja && (
                        <div
                          style={{ display: 'flex', gap: '4px', marginLeft: '4px' }}
                          onClick={(e) => e.stopPropagation()} // Prevent tab switch
                        >
                          {/* Edit Icon */}
                          <span
                            onClick={(e) => startRenaming(e, variant)}
                            style={{
                              opacity: '0.4',
                              cursor: 'pointer',
                              fontSize: '14px',
                            }}
                            onMouseEnter={(e) => e.target.style.opacity = 1}
                            onMouseLeave={(e) => e.target.style.opacity = 0.4}
                            title="Rename variant"
                          >✎</span>

                          {/* Delete Icon */}
                          <span
                            onClick={(e) => handleDeleteVariant(variant.id)}
                            style={{
                              opacity: '0.4',
                              cursor: 'pointer',
                              fontSize: '14px',
                              fontWeight: 'bold'
                            }}
                            onMouseEnter={(e) => e.target.style.opacity = 1}
                            onMouseLeave={(e) => e.target.style.opacity = 0.4}
                            title="Delete variant"
                          >×</span>
                        </div>
                      )}
                    </>
                  )}
                </div>
              ))}

              {/* Add Variant Button */}
              <div
                onClick={() => setShowAddVariantModal(true)}
                style={{
                  padding: '8px 12px',
                  backgroundColor: 'transparent',
                  color: '#20c997',
                  borderRadius: '50%',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  fontSize: '18px',
                  marginLeft: '4px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '32px',
                  height: '32px',
                  border: '1px dashed #20c997'
                }}
                title="Add New Variant"
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#20c997';
                  e.currentTarget.style.color = '#fff';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.color = '#20c997';
                }}
              >
                +
              </div>
            </div>

          </div>
        )}

        <div className="card" style={{ borderTopLeftRadius: '0', borderTopRightRadius: '0.375rem', marginTop: '-1px' }}>
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4 className="card-title mb-0">
              {id ? 'Edit' : 'Add'} Puja
              {currentEditId === id && (
                <span className="badge bg-primary ms-2" style={{ fontSize: '12px' }}>Main Puja</span>
              )}
              {currentEditId !== id && currentEditId !== 'custom-puja' && (
                <span className="badge bg-info ms-2" style={{ fontSize: '12px' }}>
                  {variants.find(v => v.id === currentEditId)?.variantType || 'Variant'}
                </span>
              )}
              {currentEditId !== id && variants.find(v => String(v.id) === String(currentEditId))?.isCustomPuja && (
                <span className="badge bg-purple text-white ms-2" style={{ fontSize: '12px', backgroundColor: '#6f42c1' }}>
                  Custom Puja
                </span>
              )}
            </h4>
          </div>
          <div className="card-body">
            {/* Style for smooth fade-in transition */}
            <style>
              {`
                @keyframes fadeIn {
                  from { opacity: 0; transform: translateY(5px); }
                  to { opacity: 1; transform: translateY(0); }
                }
              `}
            </style>
            <div className="basic-form" style={{ animation: 'fadeIn 0.4s ease-out' }}>
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                enableReinitialize={true}
              >
                {({ isSubmitting, setFieldValue, values }) => (
                  <Form>
                    <div className="row">
                      <div className="mb-3 col-md-6">
                        <label className="form-label">Puja Name</label>
                        <Field
                          name="title"
                          type="text"
                          className="form-control"
                          placeholder="Puja name"
                        />
                        <ErrorMessage
                          name="title"
                          component="div"
                          className="error-message"
                        />
                      </div>

                      {/* Slug field — only on Main Puja tab */}
                      {(!id || String(currentEditId) === String(id)) && (
                        <div className="mb-3 col-md-6">
                          <label className="form-label">URL Slug</label>
                          <Field
                            name="slug"
                            type="text"
                            className="form-control"
                            placeholder="auto-generated from title"
                          />
                          <div style={{ fontSize: 12, color: '#6c757d', marginTop: 4 }}>
                            Preview: <strong>/puja/{values.slug || <em>slug</em>}</strong>
                          </div>
                          <ErrorMessage name="slug" component="div" className="error-message" />
                        </div>
                      )}


                      {!values.isCustomPuja && (
                        <div className="mb-3 col-md-6">
                          <label className="form-label">Booking Price</label>
                          <Field
                            name="price"
                            type="text"
                            className="form-control"
                            placeholder="Booking Price"
                          />
                          <ErrorMessage
                            name="price"
                            component="div"
                            className="error-message"
                          />
                        </div>
                      )}

                      {!values.isCustomPuja && (
                        <div className="mb-3 col-md-6">
                          <label className="form-label">Acharya Payout</label>
                          <Field
                            name="panditPayout"
                            type="text"
                            className="form-control"
                            placeholder="Acharya Payout"
                          />
                          <ErrorMessage
                            name="panditPayout"
                            component="div"
                            className="error-message"
                          />
                        </div>
                      )}

                      {!values.isCustomPuja && (
                        <div className="mb-3 col-md-6">
                          <label className="form-label">Acharya Billing</label>
                          <Field
                            name="acharyaBilling"
                            type="text"
                            className="form-control"
                            placeholder="Acharya Billing"
                          />
                          <ErrorMessage
                            name="acharyaBilling"
                            component="div"
                            className="error-message"
                          />
                        </div>
                      )}

                      <div className="mb-3 col-md-6">
                        <label className="form-label">Duration</label>
                        <Field
                          name="duration"
                          type="text"
                          className="form-control"
                          placeholder="duration"
                        />
                        <ErrorMessage
                          name="duration"
                          component="div"
                          className="error-message"
                        />
                      </div>


                      <div className="mb-4 col-md-12">
                        <label className="form-label">Puja Images</label>
                        <small className="text-muted d-block mb-2">First image is the cover photo. Drag ⠿ to reorder. Up to 10 images.</small>
                        <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
                          <SortableContext items={galleryImages.map(img => img.id)} strategy={rectSortingStrategy}>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, alignItems: 'flex-start' }}>
                              {galleryImages.map((img, index) => (
                                <SortableImage key={img.id} item={img} index={index} onRemove={removeGalleryImage} />
                              ))}
                              {galleryImages.length < 10 && (
                                <div
                                  {...getGalleryRootProps()}
                                  style={{ width: 110, height: 110, border: '2px dashed #ced4da', borderRadius: 8, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#6c757d', fontSize: 12, backgroundColor: '#f8f9fa' }}
                                >
                                  <input {...getGalleryInputProps()} />
                                  <div style={{ fontSize: 24, lineHeight: 1, marginBottom: 4 }}>+</div>
                                  <div>Add Image</div>
                                </div>
                              )}
                            </div>
                          </SortableContext>
                        </DndContext>
                      </div>
                      <div className="mb-3 col-md-6">
                        {values.isCustomPuja ? (
                          <>
                            <label className="form-label">Custom Puja Status</label>
                            <Field as="select"
                              name="isCustomPuja"
                              className="form-control"
                              placeholder="Select Status"
                              onChange={(e) => {
                                // Convert string value from select to boolean
                                setFieldValue("isCustomPuja", e.target.value === "true");
                              }}
                            >
                              <option value="true">Active (Show on Frontend)</option>
                              <option value="false">Inactive (Hide from Frontend)</option>
                            </Field>
                            <small className="text-muted">Controls whether Custom Puja option is visible on the webapp</small>
                          </>
                        ) : (
                          <>
                            <label className="form-label"> Status</label>
                            <Field as="select"
                              name="isActive"
                              className="form-control"
                              placeholder="Select Status"
                              onChange={(e) => {
                                setFieldValue("isActive", e.target.value === "true");
                              }}
                            >
                              <option value="true">Active</option>
                              <option value="false">Inactive</option>
                            </Field>
                            <ErrorMessage
                              name="isActive"
                              component="div"
                              className="error-message"
                            />
                          </>
                        )}
                      </div>
                      <div className="mb-3 col-md-6">
                        <label className="form-label">Short Description</label>
                        <JoditEditor
                          value={values.shortDescription} // Bind the value to Formik's state
                          onChange={(newContent) => setFieldValue("shortDescription", newContent)}
                          config={config}
                          className="block w-full border h-80 overflow-y-auto"
                          placeholder="Short Description"
                        />
                        <ErrorMessage
                          name="description"
                          component="div"
                          className="error-message"
                        />
                      </div>

                      <div className="mb-3 col-md-6">
                        <label className="form-label">What's Included (Offerings)</label>
                        <p className="text-muted small mb-2">Type an item and press Enter or comma to add it as a tag. These appear as chips on the website.</p>
                        <div className="border rounded p-2" style={{ minHeight: 48, display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                          {(values.offerings || []).map((item, idx) => (
                            <span key={idx} style={{ display: 'inline-flex', alignItems: 'center', gap: 4, background: '#d1fae5', color: '#065f46', borderRadius: 999, padding: '3px 10px', fontSize: 13, fontWeight: 500 }}>
                              {item}
                              <button
                                type="button"
                                onClick={() => setFieldValue('offerings', values.offerings.filter((_, i) => i !== idx))}
                                style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#065f46', fontSize: 15, lineHeight: 1, padding: 0, marginLeft: 2 }}
                              >×</button>
                            </span>
                          ))}
                          <input
                            type="text"
                            placeholder="e.g. Samagri kit included"
                            style={{ border: 'none', outline: 'none', minWidth: 180, fontSize: 13, flex: 1 }}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter' || e.key === ',') {
                                e.preventDefault();
                                const val = e.target.value.trim().replace(/,$/, '');
                                if (val && !(values.offerings || []).includes(val)) {
                                  setFieldValue('offerings', [...(values.offerings || []), val]);
                                }
                                e.target.value = '';
                              }
                            }}
                          />
                        </div>
                      </div>

                      <div className="mb-3 col-md-6">
                        <label className="form-label">Puja Description</label>
                        <JoditEditor
                          value={values.description} // Bind the value to Formik's state
                          onChange={(newContent) => setFieldValue("description", newContent)}
                          config={config}
                          className="block w-full border h-80 overflow-y-auto"
                          placeholder="Description"
                        />
                        <ErrorMessage
                          name="description"
                          component="div"
                          className="error-message"
                        />
                      </div>

                      <div className="mb-3 col-md-6">
                        <label className="form-label">Legends and Fables</label>
                        <JoditEditor
                          value={values.legendsAndFables}
                          onChange={(content) => setFieldValue("legendsAndFables", content)}
                          config={config}
                          className="block w-full border h-80 overflow-y-auto"
                          placeholder="legends and fables"
                        />
                        <ErrorMessage
                          name="legendsAndFables"
                          component="div"
                          className="error-message"
                        />
                      </div>
                      <div className="mb-3 col-md-6">
                        <label className="form-label">Religious Philosophy</label>
                        <JoditEditor
                          value={values.ritualPhilosophy}
                          onChange={(content) => setFieldValue("ritualPhilosophy", content)}
                          config={config}
                          className="block w-full border h-80 overflow-y-auto"
                          placeholder="ritual philosophy"
                        />
                        <ErrorMessage
                          name="ritualPhilosophy"
                          component="div"
                          className="error-message"
                        />
                      </div>

                      <div className="mb-3 col-md-6">
                        <label className="form-label">Puja Vidhi</label>
                        <JoditEditor
                          value={values.pujaVidhi}
                          onChange={(content) => setFieldValue("pujaVidhi", content)}
                          config={config}
                          className="block w-full border h-80 overflow-y-auto"
                          placeholder="puja vidhi"
                        />
                        <ErrorMessage
                          name="pujaVidhi"
                          component="div"
                          className="error-message"
                        />
                      </div>

                      <div className="mb-3 col-md-6">
                        <label className="form-label">Samagri</label>
                        <JoditEditor
                          value={values.samagri}
                          onChange={(content) => setFieldValue("samagri", content)}
                          config={config}
                          className="block w-full border h-80 overflow-y-auto"
                          placeholder="samagri"
                        />
                        <ErrorMessage
                          name="samagri"
                          component="div"
                          className="error-message"
                        />
                      </div>
                      <div className="mb-3 col-md-6">
                        <label className="form-label">Cultural Acceptance</label>
                        <JoditEditor
                          value={values.culturalAcceptance}
                          onChange={(content) => setFieldValue("culturalAcceptance", content)}
                          config={config}
                          className="block w-full border h-80 overflow-y-auto"
                          placeholder="Cultural Acceptance"
                        />
                        <ErrorMessage
                          name="culturalAcceptance"
                          component="div"
                          className="error-message"
                        />
                      </div>
                      {/* <div className="mb-3 col-md-6">
                        <label className="form-label">Inclusions</label>
                        <JoditEditor
                          value={values.inclusions}
                          onChange={(content) => setFieldValue("inclusions", content)}
                          config={config}
                          className="block w-full border h-80 overflow-y-auto"
                        />
                        <ErrorMessage
                          name="inclusions"
                          component="div"
                          className="error-message"
                        />
                      </div> */}


                      <div className="mb-3 col-md-6">
                        <label className="form-label"> Tag</label>
                        <Select
                          name="tag"
                          options={tag}
                          isMulti
                          onChange={(selectedOptions) =>
                            setFieldValue("tag", selectedOptions)
                          }
                          value={values.tag}
                        />
                      </div>

                      <div className="mb-3 col-md-6">
                        <label className="form-label">User checklist pdf</label>
                        <input
                          name="userChecklistPdf"
                          type="file"
                          accept="application/pdf"
                          onChange={(event) => {
                            setUserChecklistPdf(event.currentTarget.files[0])
                          }}
                          className="form-control"
                        />
                        {userChecklistPdf ? (
                          <p>
                            Selected File: {userChecklistPdf.name}
                          </p>
                        ) : values?.userChecklistUrl ? (
                          <p>
                            Existing File:{" "}
                            <a
                              href={values?.userChecklistUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              View Checklist PDF
                            </a>
                          </p>
                        ) : (
                          <p>No file chosen</p>
                        )}
                      </div>
                      <div className="mb-3 col-md-6">
                        <label className="form-label">Acharya checklist pdf</label>
                        <input
                          name="panditChecklistPdf"
                          type="file"
                          accept="application/pdf"
                          onChange={(event) => {
                            setPanditChecklistPdf(event.currentTarget.files[0])
                          }}
                          className="form-control"
                        />
                        {panditChecklistPdf ? (
                          <p>
                            Selected File: {panditChecklistPdf.name}
                          </p>
                        ) : values?.panditChecklistUrl ? (
                          <p>
                            Existing File:{" "}
                            <a
                              href={values?.panditChecklistUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              View Checklist PDF
                            </a>
                          </p>
                        ) : (
                          <p>No file chosen</p>
                        )}
                      </div>

                      {/* Puja Videos Section */}
                      <div className="col-md-12 mt-4 mb-2">
                        <h5 className="border-bottom pb-2">Puja Videos</h5>
                        <small className="text-muted">Videos upload immediately on selection. Only one video can be shown on the carousel at a time.</small>
                      </div>

                      {/* Video preview modal */}
                      {previewVideoUrl && (
                        <div
                          onClick={() => setPreviewVideoUrl(null)}
                          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.82)', zIndex: 1050, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                        >
                          <div onClick={e => e.stopPropagation()} style={{ position: 'relative', width: '90%', maxWidth: 860 }}>
                            <button
                              onClick={() => setPreviewVideoUrl(null)}
                              style={{ position: 'absolute', top: -36, right: 0, background: 'none', border: 'none', color: 'white', fontSize: 28, cursor: 'pointer', lineHeight: 1 }}
                            >×</button>
                            <video
                              src={previewVideoUrl}
                              controls
                              autoPlay
                              style={{ width: '100%', borderRadius: 8, maxHeight: '80vh' }}
                            />
                          </div>
                        </div>
                      )}

                      <div className="mb-4 col-md-12">
                        {galleryVideos.length > 0 && (
                          <div className="mb-3" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                            {galleryVideos.map(v => (
                              <div key={v.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 14px', border: '1px solid #dee2e6', borderRadius: 8, backgroundColor: '#f8f9fa' }}>
                                <div style={{ fontSize: 20, flexShrink: 0 }}>🎬</div>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                  {v.url ? (
                                    <button
                                      type="button"
                                      onClick={() => setPreviewVideoUrl(v.url)}
                                      style={{ background: 'none', border: 'none', padding: 0, color: '#0d6efd', cursor: 'pointer', fontSize: 13, wordBreak: 'break-all', textAlign: 'left' }}
                                    >
                                      ▶ {v.name}
                                    </button>
                                  ) : (
                                    <span style={{ fontSize: 13, color: '#6c757d' }}>{v.name}</span>
                                  )}
                                  {v.uploading && (
                                    <div style={{ marginTop: 6 }}>
                                      <div style={{ height: 4, background: '#dee2e6', borderRadius: 2, overflow: 'hidden' }}>
                                        <div style={{ height: '100%', width: `${v.progress}%`, background: '#6610f2', transition: 'width 0.3s' }} />
                                      </div>
                                      <small style={{ color: '#6c757d' }}>Uploading... {v.progress}%</small>
                                    </div>
                                  )}
                                </div>
                                {!v.uploading && v.url && (
                                  <div className="form-check form-switch mb-0" style={{ flexShrink: 0 }}>
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      id={`carousel-${v.id}`}
                                      checked={v.showOnCarousel}
                                      onChange={() => toggleVideoCarousel(v.id)}
                                    />
                                    <label className="form-check-label" htmlFor={`carousel-${v.id}`} style={{ fontSize: 12, whiteSpace: 'nowrap' }}>
                                      {v.showOnCarousel ? 'On Carousel' : 'Off Carousel'}
                                    </label>
                                  </div>
                                )}
                                {!v.uploading && (
                                  <button
                                    type="button"
                                    onClick={() => removeVideo(v.id)}
                                    style={{ flexShrink: 0, background: 'none', border: 'none', color: '#dc3545', cursor: 'pointer', fontSize: 20, padding: '0 4px', lineHeight: 1 }}
                                    title="Remove video"
                                  >×</button>
                                )}
                              </div>
                            ))}
                          </div>
                        )}
                        <input
                          ref={videoInputRef}
                          type="file"
                          accept="video/*"
                          style={{ display: 'none' }}
                          onChange={handleVideoFileSelected}
                        />
                        <button
                          type="button"
                          className="btn btn-outline-secondary btn-sm"
                          onClick={handleAddVideoClick}
                          disabled={galleryVideos.some(v => v.uploading)}
                        >
                          + Add Video
                        </button>
                      </div>
                      {/* <div className="mb-3 col-md-12">
                        <label className="form-label">Checklist</label>
                        <FieldArray name="checklist">
                          {() => (
                            <>
                              {Object.keys(values.checklist).map((checklistKey, checklistIndex) => (
                                <div key={checklistIndex} className="mb-6 border-b pb-4">
                                  <b className="">{checklistKey}</b>
                                  {values.checklist[checklistKey].map((item, itemIndex) => (
                                    <div key={itemIndex} className="mb-4 flex flex-col space-y-2">
                                      <Field
                                        name={`checklist.${checklistKey}[${itemIndex}].title`}
                                        placeholder="Title"
                                        className="form-control"
                                      />
                                      <Field
                                        name={`checklist.${checklistKey}[${itemIndex}].text`}
                                        placeholder="Text"
                                        as="textarea"
                                        className="form-control"
                                      />
                                      <Field
                                        name={`checklist.${checklistKey}[${itemIndex}].imageUrl`}
                                        placeholder="image url"
                                        className="form-control"
                                      />
                                      <button
                                        type="button"
                                        className="btn btn-light btn-sm mt-2"
                                        onClick={() => {
                                          const newItems = values.checklist[checklistKey].filter((_, idx) => idx !== itemIndex);
                                          setFieldValue(`checklist.${checklistKey}`, newItems);
                                        }}
                                      >
                                        Remove Item
                                      </button>
                                    </div>
                                  ))}

                                  <button
                                    type="button"
                                    className="btn btn-light btn-sm"
                                    onClick={() => {
                                      const newItem = { title: '', text: '' };
                                      setFieldValue(`checklist.${checklistKey}`, [...values.checklist[checklistKey], newItem]);
                                    }}
                                  >
                                    Add Item to {checklistKey}
                                  </button>

                                  <button
                                    type="button"
                                    className="btn btn-light btn-sm ms-2"
                                    onClick={() => {
                                      const updatedChecklist = { ...values.checklist };
                                      delete updatedChecklist[checklistKey];
                                      setFieldValue('checklist', updatedChecklist);
                                    }}
                                  >
                                    Remove Checklist
                                  </button>
                                </div>
                              ))}

                              <div className="mb-6">
                                <Field
                                  name="checklistName"
                                  placeholder="Enter new checklist name"
                                  value={values.checklistName || ''} 
                                  onChange={(e) => setFieldValue('checklistName', e.target.value)}
                                  className="p-2 border rounded-md w-full focus:ring-2 focus:ring-indigo-500"
                                />
                                <button
                                  type="button"
                                  className="btn btn-light btn-sm ms-2"
                                  onClick={() => {
                                    const newHeading = (values.checklistName || '').trim(); 
                                    if (newHeading && !values.checklist[newHeading]) {
                                      setFieldValue(`checklist.${newHeading}`, [{ title: '', text: '' }]);
                                      setFieldValue('checklistName', '');
                                    }
                                  }}
                                >
                                  Add New Checklist
                                </button>
                              </div>
                            </>
                          )}
                        </FieldArray>
                      </div> */}

                    </div>

                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="btn btn-primary"
                    >
                      Save
                    </button>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div >
    </div >
  )
}